import { makeUseAxios } from "axios-hooks";

import api from "../services/API";


export const useApi = makeUseAxios({ axios: api });
